import Avatar from 'components/profile/Avatar';

export default {
	'components.Avatar': {
		factory: Avatar,
	},
};
